module.exports = __webpack_public_path__ + "img/sec2.4.25427879.png";